import bitcasino from "./siteConfigs/bitcasino";
import livecasino from "./siteConfigs/livecasino";
import sportsbet from "./siteConfigs/sportsbet";

const configs: SiteRecord<SiteConfig> = {
  bitcasino,
  livecasino,
  sportsbet,
};

export default configs;
